/**
 * Owner-facing names for Careem adjustment category keys. Careem's keys are
 * internal jargon ("CLAWBACK"); the owner needs plain language for what the
 * charge actually is. Shared by the onboarding money breakdown and the payouts
 * match panel so both surfaces read the same. Keys not listed fall back to
 * sentence-cased UPPER_SNAKE.
 */
export const CAREEM_CATEGORY_LABELS: Record<string, string> = {
  CLAWBACK: 'Customer refunds & quality issues',
  BANK_TRANSFER_FEE: 'Bank transfer fee',
  CPLUS_FEE: 'Careem Plus',
  PROMO_SHARING: 'Promo funded by Careem',
};

/**
 * Humanize a Careem adjustment category key for the owner — a friendly mapped
 * name where we have one (`CLAWBACK` → "Customer refunds & quality issues"),
 * else UPPER_SNAKE → sentence case. Unknown/blank falls back to a generic label
 * so a real deduction always reads as a named line, never an anonymous number.
 */
export function humanizeCareemCategory(category: string): string {
  const key = category.trim().toUpperCase();
  if (CAREEM_CATEGORY_LABELS[key]) return CAREEM_CATEGORY_LABELS[key];
  const cleaned = category.trim().replace(/_/g, ' ').toLowerCase();
  if (cleaned === '' || cleaned === 'unknown') return 'Other platform adjustment';
  return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
}
